import { useCallback, useContext } from 'react';
import { TrackingContext } from '@elementary/common-ui/providers/tracking';
import {
  FeedbackTest,
  FeedbackTrackingProperties,
  TrackFeedbackEvent,
} from '../types';

const useFeedbackTracking = ({
  test,
  resultId,
  properties: baseProperties,
}: {
  test: FeedbackTest;
  resultId: string;
  properties?: FeedbackTrackingProperties;
}): TrackFeedbackEvent => {
  const tracking = useContext(TrackingContext);

  return useCallback(
    (eventKey, properties = {}) => {
      tracking?.sendTrackingEvent({
        eventName: tracking.analytics.events[eventKey],
        properties: {
          test_id: test.id,
          test_type: test.type,
          result_id: resultId,
          ...baseProperties,
          ...properties,
        },
      });
    },
    [tracking, test.id, test.type, resultId, baseProperties],
  );
};

export default useFeedbackTracking;
